import { useContext, useState } from 'react';
import {
  ListResponse,
  updateMyList,
  ListType,
  ListEntry,
  myListApi,
  SubCartDetail,
} from '@commerce-cart-webcomponents/sdk';
import { useDispatch } from 'react-redux';
import { SocialShareLink } from '@commerce-webcomponents/ui';
import { useTranslation } from '@nextgen-web-framework/all';
import { ListMenu } from '../../lists/components/list-menu/ListMenu';
import { CartEllipsisMenu } from '../../cart-ellipsis-menu/CartEllipsisMenu';
import { AllCustomListContext, CustomListContextType, ModalWrapper } from '../../../common';
import styles from './GCOEllipsesMenu.module.scss';

interface GCOEllipsesMenuProps {
  isTypeCart: boolean;
  itemCart: SubCartDetail;
  itemList: ListResponse;
  mainIndex: number;
  listUpdatedCb?: (listId: string, isDeleted?: boolean, isRemovedFromMyShop?: boolean) => void;
  isReceiver?: boolean;
}

export const GCOEllipsesMenu = ({
  isTypeCart,
  itemCart,
  itemList,
  mainIndex,
  listUpdatedCb,
  isReceiver = false,
}: GCOEllipsesMenuProps) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const currentUrl = window.location.href;
  const newUrl = currentUrl.replace('/myshop', '/list');
  const [showModal, setShowModal] = useState(false);
  const [invalidProducts, setInvalidProducts] = useState<ListEntry[]>([]);

  const primaryLabelText = t('cart.invalidProduct.cancel');
  const secondaryLabelText = t('cart.invalidProduct.removeItem');
  const headLineText = t('cart.invalidProductModal.heading');
  const description = t('cart.invalidProductModal.description');

  const { updateCustomList }: CustomListContextType = useContext(AllCustomListContext);

  const deleteInvalidProduct = () => {
    const invalidProductEntrtIds = invalidProducts.map((product) => product.entryId);
    myListApi
      .removeEntryFromList({
        listId: itemList?.listId,
        entryId: invalidProductEntrtIds as number[],
      })
      .then((res) => {
        listUpdatedCb?.(itemList?.listId || '');
        itemList && dispatch(updateMyList(itemList));
        updateCustomList(res);
        setShowModal(false);
      });
  };

  const showInvalidProductModal = () => {
    const restrictedSharingProduct = itemList?.payLoad?.entries?.filter(
      (entry) => entry.product.flags?.restrictFromSharing,
    );

    if (restrictedSharingProduct?.length) {
      setInvalidProducts(restrictedSharingProduct);
      setShowModal(true);
    }

    return Boolean(restrictedSharingProduct?.length);
  };

  return (
    <>
      {isTypeCart ? (
        <div className={styles['commerce-cart-gco-line-item-entry-details-icon']}>
          {mainIndex === 0 && (!itemCart.entries || itemCart?.entries?.length === 0) ? null : (
            <CartEllipsisMenu currentCartId={itemCart.subCartId} />
          )}
        </div>
      ) : (
        !isReceiver && (
          <div className={styles['commerce-gco-card-icons']}>
            {itemList.listType === ListType.Shareable &&
              (showModal ? (
                <ModalWrapper
                  headLineText={headLineText}
                  description={description}
                  primaryButtonLabel={primaryLabelText}
                  secondaryButtonLabel={secondaryLabelText}
                  onPrimarySuccess={() => setShowModal(false)}
                  onSecondarySuccess={deleteInvalidProduct}
                  productData={invalidProducts}
                />
              ) : (
                <div
                  aria-label="share-btn-container"
                  role="button"
                  tabIndex={0}
                  onKeyDown={showInvalidProductModal}
                  onClick={showInvalidProductModal}
                  data-testId={'share-btn-container'}
                >
                  <SocialShareLink
                    linkProps={{
                      category: 'mylist',
                      data: '',
                      fullUrl: `${newUrl}/${itemList.listId}`,
                      title: itemList.payLoad?.name,
                    }}
                    isCustomUrl={false}
                    shareUrl={false}
                  />
                </div>
              ))}
            {itemList && (
              <ListMenu
                key="list-menu"
                listDetails={itemList}
                showInMyShop={true}
                onListUpdate={(list?: ListResponse, isDeleted?: boolean, isRemovedFromMyShop?: boolean) => {
                  listUpdatedCb?.(list?.listId || '', isDeleted, isRemovedFromMyShop);
                  list && dispatch(updateMyList(list));
                }}
                customClass="myList-page-card-actions"
              />
            )}
          </div>
        )
      )}
    </>
  );
};

export type { GCOEllipsesMenuProps };
